import React, { useState } from 'react';


const SmallTextGenerators = () => {
  const [inputText, setInputText] = useState('');
  const [outputText, setOutputText] = useState('');
  const [selectedOption, setSelectedOption] = useState('smallcaps');


  const handleInputChange = (e) => {
    setInputText(e.target.value);
    generateText(e.target.value, selectedOption);
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    generateText(inputText, e.target.value);
  };

  const generateText = (text, option) => {
    switch (option) {
      case 'smallcaps':
        setOutputText(text.toLowerCase().replace(/^(.)|\s(.)/g, (match) => match.toUpperCase()));
        break;
      case 'superscript':
        setOutputText(text.replace(/./g, (match) => `<sup>${match}</sup>`));
        break;
      case 'subscript':
        setOutputText(text.replace(/./g, (match) => `<sub>${match}</sub>`));
        break;
      case 'allcaps':
        setOutputText(text.toUpperCase());
        break;
      default:
        setOutputText('');
    }
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label

  const handleCopyText = () => {
    navigator.clipboard.writeText(outputText.replace(/<[^>]*>/g, '')); // Strips HTML tags before copying
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };

   // Clear input fields
   const clearFields = () => {
    setInputText('');
    setOutputText('');
    setSelectedOption('');
  };

     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(inputText);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
        <div className="card-body">          
          <div className="mb-3">
            <textarea
              className="form-control"
              rows="4"
              value={inputText}
              onChange={handleInputChange}
              placeholder="Enter your text here"
            />
          </div>

          <div className="mb-3">
            <select
              className="form-select"
              value={selectedOption}
              onChange={handleOptionChange}
            >
              <option value="smallcaps">Small Caps</option>
              <option value="superscript">Super Script</option>
              <option value="subscript">Sub Script</option>
              <option value="allcaps">All Caps</option>
            </select>
          </div>

          <div
            className="p-3 mb-3 border rounded "
            dangerouslySetInnerHTML={{ __html: outputText }}
          />
          

          <button
            className="btn btn-primary mt-3"
            onClick={handleCopyText}
          >
         {copyButtonLabel}
         </button>

          <button className="btn btn-danger mt-3" onClick={clearFields}>
            Clear
          </button>
        </div>

        <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>

      </div>
  );
};

export default SmallTextGenerators;
